import React, {useState} from "react";
import Select from "react-select";
import {Input, InputWrapperDiv} from "../../../../../../../../../components/ui/Input";
import select_styles from "../../../../../../../../../layouts/elements";
import {Button} from "../../../../../../../../../components/ui/Button";

const OPTIONS = [
    {value: "1", label: "Regular musician"},
    {value: "2", label: "Renfort"},
]

export default function AddPersonPopupForm({usersList, cancelBtn, saveBtn, handlePopup}) {
    const [directSelFormOpt, setDirectSelFormOpt] = useState("1")
    const [directSel, setDirectSel] = useState("")
    const [userFilter, setUserFilter] = useState(usersList.filter(user => user.category === 'regular'));

    const changeHandler = (value, opt) => {
        if (opt === 'radio-button') {
            const user_filter = usersList.filter(user => {
                const filter_name = value === '1' ? "regular" : "renfort";
                return user.category === filter_name
            })
            setUserFilter(user_filter)
            setDirectSelFormOpt(value)
        } else {
            setDirectSel({...value})
        }
    }

    const handleClickFactory = (e) => {
        const buttonName = e.target.name

        if (buttonName === 'save') {
            handlePopup({
                type: "save",
                context_data: {
                    selFormOption: directSelFormOpt,
                    selected: directSel,
                }
            })
        }
        if (buttonName === 'cancel') {
            handlePopup({type: "cancel"})
        }
        // if (buttonName === 'ok') {
        //     return handlePopup({type: "ok"})
        // }
    };

    return (<>
        <div className="row mb-3">
            <Input
                name="direction_manager"
                type={"radio"}
                options={OPTIONS}
                value={directSelFormOpt}
                style={{minWidth: "250px", width: "50%", marginLeft: "10px"}}
                classNameDiv='col-sm-6'
                onChange={val => changeHandler(val, "radio-button")}
                required
            />
        </div>

        <div>
            <Select
                options={userFilter}
                value={directSel}
                onChange={val => changeHandler(val, "formOpt")}
                styles={select_styles}
                isSearchable={true}
                unstyled
            />
        </div>

        <Button name="save" onClick={(e) => handleClickFactory(e)}
                variant="round" bWidth="small" styling="plain" className='mx-3' proposueButton="green">{saveBtn}
        </Button>
        <Button name="cancel" onClick={(e) => handleClickFactory(e)}
                variant="round" bWidth="small" styling="bordered" className='mx-3'>{cancelBtn}
        </Button>
    </>)
}